import { Component, Input, OnInit } from '@angular/core'
import { TableModule } from 'primeng/table'
import { TagModule } from 'primeng/tag'
import { ButtonModule } from 'primeng/button'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { TooltipModule } from 'primeng/tooltip'
import { CurrencyPipe } from '@angular/common'

@Component({
  selector: 'app-affair-products',
  templateUrl: './affair-products.component.html',
  styleUrls: ['./affair-products.component.scss'],
  standalone: true,
  imports: [
    TableModule,
    TagModule,
    ButtonModule,
    ProgressSpinnerModule,
    TooltipModule,
    CurrencyPipe,
  ],
})
export class AffairProductsComponent implements OnInit {
  @Input() products: any
  @Input() productsLoading: boolean

  constructor() {}

  ngOnInit() {}
}
